export const customInputRules = (rulesObj = {}) => {
  const rules = [];
  if (rulesObj.required) {
    const reqFunc = (val) => !!val || "Это поле обязательно";
    rules.push(reqFunc);
  }
  if (rulesObj.max !== undefined) {
    const maxFunc = (val) =>
      !val ||
      Number(val) <= rulesObj.max ||
      `Максимальное значение ${rulesObj.max}`;
    rules.push(maxFunc);
  }
  return rules;
};
